import {API_URL, authHeaders} from "./index";

export async function apiGetAiSummary(groupId) {
    const res = await fetch(`${API_URL}/admin/groups/${groupId}/ai-summary`, {headers: authHeaders()});
    return res.json();
}

export async function apiGenerateAiSummary(groupId) {
    const res = await fetch(`${API_URL}/admin/groups/${groupId}/ai-summary`, {
        method: "POST",
        headers: authHeaders(),
    });
    return res.json();
}
